import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { isNil } from 'lodash';
import classnames from 'classnames';
import { branch, renderNothing } from 'recompose';

import { Text } from 'components/core/Typography';

import './reviewRatingDetails.scss';

const enhance = branch(
	(props) => !props.priceRating || !props.serviceRating || !props.cleanlinessRating,
	renderNothing
);

export function ReviewRatingDetails({
	className, priceRating, serviceRating, cleanlinessRating, recommended
}) {
	return (
		<div className={classnames(className, 'review-rating-details')}>
			{!isNil(recommended) &&
				<div className="rating">
					<Text size="small" className="rating-name">
						Recommended
					</Text>
					<Text className="rating-value">
						{recommended ? ' Yes' : ' No'}
					</Text>
				</div>
			}
			{Children.toArray([priceRating, serviceRating, cleanlinessRating].map((rating) => (
				<div className="rating">
					<Text size="small" className="rating-name">
						{rating.text}
					</Text>
					<Text className="rating-value">
						{rating.value}/5 ({rating.valueText})
					</Text>
				</div>
			)))}
		</div>
	);
}

export const ratingDetailsType = PropTypes.shape({
	text: PropTypes.string,
	value: PropTypes.number,
	valueText: PropTypes.string
});

ReviewRatingDetails.propTypes = {
	recommended: PropTypes.bool,
	className: PropTypes.string,
	priceRating: ratingDetailsType,
	serviceRating: ratingDetailsType,
	cleanlinessRating: ratingDetailsType
};

export default enhance(ReviewRatingDetails);
